export enum JoyBadgeLevelEnum {
    // Should be replaced by JoyBadgeLevelEnum.HIGH_POTENTIAL_AUTO OR JoyBadgeProgramEnum.HIGH_POTENTIAL
    HIGH_POTENTIAL = 'highpotential',
    HIGH_POTENTIAL_AUTO = 'high-potential-auto',
    MALT_LINKER = 'maltlinker',
    NEW = 'new',
    SUPER_MALTER = 'supermalter',
    VERIFIED = 'verified',
}

export enum JoyBadgeProgramEnum {
    HIGH_POTENTIAL = 'program_high-potential',
}

export type BadgesTypes = `${JoyBadgeLevelEnum | JoyBadgeProgramEnum}`;
